/* Gift with purchase, added at checkout.

   Shopify's Buy-X-Get-Y automatic discounts only make an item free when it is
   ALREADY in the cart; they never add it. On Shopify Basic the checkout itself
   can't add products either, so this script adds the qualifying gifts at the
   moment the customer clicks Checkout, then hands over to checkout.

   Gifts never show in the cart:
   - every storefront page load removes gift lines (they only live between the
     Checkout click and the checkout page), and
   - the drawer / cart page show a one-line note instead ("free at checkout").

   Safety (after the 2026-09 incident, when an expired discount left gifts at
   full price): after adding, the cart is re-read and any gift line that is not
   $0 is removed before checkout opens. Past `endsAt` nothing is added at all.

   Thresholds in snippets/gift-tiers.liquid are in shop currency (CAD) and are
   converted with Shopify.currency.rate, like Shopify converts the discounts'
   minimum purchase amounts. Spend EXCLUDES gift lines. */
(function () {
  var cfgEl = document.querySelector('[data-gift-tiers]');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent) || {}; } catch (e) { return; }
  var TIERS = (CFG.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
  if (!TIERS.length) return;

  var PROP = '_gift';
  var S = window.Shopify || {};
  var root = (S.routes && S.routes.root) || '/';
  var rate = Number(S.currency && S.currency.rate) || 1;
  var currency = (S.currency && S.currency.active) || 'CAD';
  var active = !CFG.endsAt || Date.now() < Date.parse(CFG.endsAt);

  function isGift(line) { return !!(line.properties && line.properties[PROP]); }

  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  // Resolves to `fallback` if `promise` hasn't settled within `ms`.
  function within(ms, promise, fallback) {
    return Promise.race([promise, new Promise(function (res) { setTimeout(function () { res(fallback); }, ms); })]);
  }

  function spendCents(cart) {
    var cents = 0;
    cart.items.forEach(function (l) { if (!isGift(l)) cents += l.final_line_price; });
    return cents;
  }
  function tierCents(t) { return Math.round(t.min * rate * 100); }
  /* Best tier only: Shopify won't apply two Buy-X-Get-Y discounts to the same
     purchase (the second gift came up unpaid in testing), so tiers upgrade
     rather than stack. */
  function earned(cart) {
    if (!active) return [];
    var s = spendCents(cart);
    var got = TIERS.filter(function (t) { return s >= tierCents(t); });
    return got.length ? [got[got.length - 1]] : [];
  }

  function removeGifts(items) {
    var updates = {}, n = 0;
    items.forEach(function (l) { if (isGift(l)) { updates[l.key] = 0; n++; } });
    return n ? post('cart/update.js', { updates: updates }) : Promise.resolve(null);
  }

  function money(cents) {
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(navigator.language || 'en-CA', {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  /* ---- Notes in the drawer / cart page ------------------------------------ */
  function renderNotes(cart) {
    var els = document.querySelectorAll('[data-gift-note]');
    if (!els.length) return;
    var text = '';
    if (active && cart && cart.item_count > 0) {
      var s = spendCents(cart);
      var got = earned(cart);
      var next = TIERS.filter(function (t) { return s < tierCents(t); })[0];
      if (got.length) text = 'Free at checkout: ' + got[0].title + '.';
      if (next) text += (text ? ' Spend ' + money(tierCents(next) - s) + ' more to upgrade to a free ' : 'Spend ' + money(tierCents(next) - s) + ' more for a free ') + next.title + '.';
    }
    els.forEach(function (el) { el.textContent = text; el.hidden = !text; el.setAttribute('data-gift-note-ready', ''); });
  }
  // One cart read at a time; a request made meanwhile runs once more afterwards,
  // so the note always ends on the latest cart.
  var reading = false, readAgain = false;
  function refreshNotes() {
    if (reading) { readAgain = true; return; }
    reading = true;
    getCart().then(renderNotes).catch(function () {}).then(function () {
      reading = false;
      if (readAgain) { readAgain = false; refreshNotes(); }
    });
  }
  // The drawer swaps in a fresh (empty) footer every time it opens or changes,
  // without a cart write or event to hook: fill any note that hasn't been filled.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (document.querySelector('[data-gift-note]:not([data-gift-note-ready])')) refreshNotes();
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---- Page load: clear leftover gift lines --------------------------------- */
  function cleanup() {
    return getCart().then(function (cart) {
      if (!cart.items.some(isGift)) { renderNotes(cart); return; }
      return removeGifts(cart.items).then(function () {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        refreshNotes();
      });
    }).catch(function () {});
  }
  cleanup();
  // Back button from checkout can restore this page from the bfcache without
  // re-running scripts: unlock the checkout handler and clean up again.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { going = false; cleanup(); }
  });

  // The drawer re-renders its footer after every change; refill the note after it.
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartWrite = /\/cart\/(add|change|update|clear)\.js/.test(url);
    return origFetch.apply(this, arguments).then(function (res) {
      if (isCartWrite && res.ok && !going) setTimeout(refreshNotes, 350);
      return res;
    });
  };
  ['cart:open', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(refreshNotes, 350); });
  });

  /* ---- Checkout: add earned gifts, make sure they're free, continue --------- */
  var going = false;
  function toCheckout(proceed) {
    if (going) return;
    going = true;
    var flow = getCart().then(function (cart) {
      var want = earned(cart);
      return removeGifts(cart.items).then(function () {
        if (!want.length) return;
        return post('cart/add.js', {
          items: want.map(function (t) {
            var props = {}; props[PROP] = 'Free gift';
            return { id: t.variant, quantity: 1, properties: props };
          })
        }).then(getCart).then(function (after) {
          // Never charge for a gift: if a discount didn't apply, take the gift out.
          var unpaid = after.items.filter(function (l) { return isGift(l) && l.final_line_price > 0; });
          return removeGifts(unpaid);
        });
      });
    });
    within(8000, flow.then(function () { return 'ok'; }), 'timeout')
      .then(function (state) {
        if (state === 'ok') return;
        // Slow or failed: leave no unverified gift behind, then continue anyway.
        return within(3000, getCart().then(function (c) { return removeGifts(c.items); }), null);
      })
      .catch(function () {
        return within(3000, getCart().then(function (c) { return removeGifts(c.items); }), null);
      })
      .then(function () { proceed(); }, function () { proceed(); });
  }

  // Drawer: <a href="/checkout">. Cart page: <button type="submit" name="checkout">.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var href = a.getAttribute('href') || '';
    if (!/(^|\/)checkout(\/|\?|$)/.test(href)) return;
    e.preventDefault();
    toCheckout(function () { location.href = a.href; });
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (!sub || sub.name !== 'checkout') return;
    e.preventDefault();
    toCheckout(function () { location.href = root + 'checkout'; });
  }, true);

  window.SoraGiftGate = { tiers: TIERS, active: active, refresh: refreshNotes };
})();
